import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import FeaturesRequested from '../../application/core/events/FeaturesRequested';
import { connect } from 'react-redux';
import DispatchProps, { mapDispatchToProps } from '../../application/core/DispatchProps';

class Features extends React.PureComponent<RouteComponentProps & DispatchProps> {
    public componentDidMount(): void {
        this.props.dispatch(new FeaturesRequested([]));
    }

    public render(): JSX.Element | null {
        return null;
    }
}

export default connect(mapDispatchToProps)(withRouter(Features));



// WEBPACK FOOTER //
// ./src/view/admin/Features.tsx